export default __webpack_public_path__ + "static/media/parties-and-events.63c6bd17.jpg";